<template>
  <div class="home" v-loading="Loading" element-loading-text="Loading......" >
    <div><h1>{{Title}}</h1></div>
    <el-divider ></el-divider>
    <div>&nbsp;</div>
    <el-row v-if="QuestionOpen" :gutter="20">
      <el-col :span="24">
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle1 pre-wrap-text"><span>{{Content}}</span></el-col>
        </el-row>        
        <el-divider ></el-divider>
        <el-input style="width: 100%;display: none"  v-model="userName" type="text"  />
        <div v-for="item in QuestionObj" :key="item.QUESTION_GUID" style="margin-bottom: 10px;">
          <div v-if="item.QUESTION_TYPE == '分隔線'" >
            <!-- <el-divider class="css-divider-style-bg1" content-position="center">{{ item.QUESTION }}</el-divider> -->
            <div style="font-size: 14px; color: #303133; font-weight: 500;">{{ item.QUESTION }}</div>
          </div>
          <div  v-else>
            <el-row :gutter="20" >
              <el-col :span="24" class="inputStyle1">
                <div class="pre-wrap-text" style="padding-left: 70px;">
                  {{ item.QUESTION }}
                </div>
              </el-col>
            </el-row>              
            <el-row :gutter="20" >
              <el-col :span="1" class="inputStyle1"><span> </span></el-col>
              <el-col :span="18">
                <el-select style="width: 100%;" v-if="item.QUESTION_TYPE == '單選_下拉式'" v-model="item.QUESTION_ANS" placeholder="請選擇">
                  <el-option
                    v-for="itemOP in item.QUESTION_ARR"
                    :key="itemOP.ID"
                    :label="itemOP.ans"
                    :value="itemOP.ans">
                  </el-option>
                </el-select>
                <el-input style="width: 100%;" v-if="item.QUESTION_TYPE == '單選_下拉式' && item.QUESTION_ANS == '其他'  " v-model="item.QUESTION_ANS_REMARK" type="text" placeholder="選其他時請填寫此欄位" data-space-bottom="0.5rem"  clearable />
                
                <template v-if="item.QUESTION_TYPE == '單選'" >
                  <div style="text-align: left;">
                    <el-radio v-model="item.QUESTION_ANS" v-for="itemOP in item.QUESTION_ARR" :key="itemOP.ID" :label="itemOP.ans">{{itemOP.ans}}</el-radio>
                  </div>
                </template>
                <el-input style="width: 100%;" v-if="item.QUESTION_TYPE == '單選' && item.QUESTION_ANS == '其他'  " v-model="item.QUESTION_ANS_REMARK" type="text" placeholder="選其他時請填寫此欄位" data-space-bottom="0.5rem"  clearable />

                <el-select style="width: 100%;" v-if="item.QUESTION_TYPE == '多選_下拉式'" v-model="item.QUESTION_ANS" multiple placeholder="請選擇">
                  <el-option
                    v-for="itemOP in item.QUESTION_ARR"
                    :key="itemOP.ID"
                    :label="itemOP.ans"
                    :value="itemOP.ans">
                  </el-option>
                </el-select>
                <el-input style="width: 100%;" v-if="item.QUESTION_TYPE == '多選_下拉式' && item.QUESTION_ANS.indexOf('其他') !== -1  " v-model="item.QUESTION_ANS_REMARK" type="text" placeholder="選其他時請填寫此欄位" data-space-bottom="0.5rem"  clearable />
                
                <template v-if="item.QUESTION_TYPE == '多選'" >
                  <div style="text-align: left;">
                    <el-checkbox-group v-model="item.QUESTION_ANS">
                      <el-checkbox v-for="itemOP in item.QUESTION_ARR" :key="itemOP.ID" :label="itemOP.ans"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template><el-input style="width: 100%;" v-if="item.QUESTION_TYPE == '多選' && item.QUESTION_ANS.indexOf('其他') !== -1  " v-model="item.QUESTION_ANS_REMARK" type="text" placeholder="選其他時請填寫此欄位" data-space-bottom="0.5rem"  clearable />
                

                <el-input style="width: 100%;" v-if="item.QUESTION_TYPE == '短填寫'" v-model="item.QUESTION_ANS" type="text" placeholder="請填寫" data-space-bottom="0.5rem"  clearable />
                <el-input style="width: 100%;" v-if="item.QUESTION_TYPE == '長填寫'" v-model="item.QUESTION_ANS" type="textarea" :rows="2" placeholder="請填寫" data-space-bottom="0.5rem"  clearable />
                
                <el-date-picker v-if="item.QUESTION_TYPE == '日期時間'"
                  style="float: left;"
                  v-model="item.QUESTION_ANS"
                  type="datetime"
                  range-separator="至"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期">
                </el-date-picker>
              </el-col>
            </el-row>
          </div>
        </div>
 
        <el-divider ></el-divider>

        <el-row :gutter="20" >
          <el-col v-if="false" :span="24" class="inputStyle1"><el-button type="success" @click="submitActionTxt" plain>送出..</el-button></el-col>
          <el-col :span="24" class="inputStyle1"><el-button type="success" :disabled="isCounting" @click="submitAction();startCountdown();" plain>{{ isCounting ? countdown + ' 秒後可重試' : '送出' }}</el-button></el-col>
        </el-row>
      </el-col>
    </el-row>
    
  </div>
</template>
<style scoped>
  .css-divider-style-bg1{
    background-color: #dcdfe61c;
  }
  .inputStyle1{
    text-align: left;
    min-height: 43px;
    font-size: 14px;
    color: #606266;
    /*line-height: 44px;*/
    font-weight: 500;
  }
  .inputStyle2{
    text-align: left;
    min-height: 43px;
    font-size: 14px;
    color: #606266;
    /*line-height: 22px;*/
    font-weight: 500;
  }
  .paddingStyle1{
    padding-left: 34px !important;
  }
  .inputStyle3{
    min-height: 50px;
  }
  .pre-wrap-text {
    margin: 10px 0px 10px 0px;
    white-space: pre-line; /* 保留換行與空格 */
    word-break: break-word;
  }
</style>
<script>
// @ is an alias to /src
import { setSurveyOptionAnsToTxtByJson,setJsonDateDecode,getSurveyMainInfoByEnable,GetSurveyTitleInfo,GetSurveyOptionInfo,setSurveyOptionAnsByJson,setToyyyymmdd } from "@/api/portalAction"
//import { Decimal } from 'decimal.js'
export default {
  name: 'ResponsepageView',
  
  data () {
    return {
      Loading:false,
      Title:"載入中",
      Content:"載入中....",
      QuestionObj:[],
      userName:'',
      QuestionOpen:false,
      countdown: 10,     // 倒數秒數
      isCounting: false, // 是否正在倒數
      timer: null        // 計時器 ID
    }
  },
  watch: {
    //監聽用的
    //TestXXX: function(){      this.XXX= this.OOO+"_"+this.YYYY;    },

  },
  created: function(){
    //vue創建需要的部分
  },
  mounted: function () {
    this.getSurveyInfoByGuid();
    this.userName = this.generateSecureGUID();
  },
  methods: {
    startCountdown() {
      // 防止重複啟動
      if (this.isCounting) return;

      this.isCounting = true;
      this.countdown = 10;

      // 啟動計時器
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          // 倒數結束
          this.isCounting = false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    ///---
    async submitActionTxt(){
      this.Loading = true;
      this.userName = this.generateSecureGUID();
      //var insertOk = true;
      var objArr =[];
      var err = "";
      for(var idx in this.QuestionObj){
        if(this.QuestionObj[idx]["QUESTION_TYPE"] != "分隔線"){
          var obj = {};
          var tmpId = this.QuestionObj[idx]["ID"];
          var tmpQuestion = this.QuestionObj[idx]["QUESTION"];
          var tmpQuestionAnsRe = this.QuestionObj[idx]["QUESTION_ANS_REMARK"];
          var tmpQuestionAns = "";
          
          if(this.QuestionObj[idx]["QUESTION_ANS"] == "" || this.QuestionObj[idx]["QUESTION_ANS"] == null){
            err += "【"+tmpQuestion+"】未填無法送出，請確認是否忘記填寫!\r\n";
          }else{
            if(this.QuestionObj[idx]["QUESTION_ANS"] == "其他" && (this.QuestionObj[idx]["QUESTION_ANS_REMARK"] =="" || this.QuestionObj[idx]["QUESTION_ANS_REMARK"] == null)){
              err += "【"+tmpQuestion+"】選其他時，請填寫選項下方輸入框，說明實際原因!\r\n";
            }
            if(this.QuestionObj[idx]["QUESTION_TYPE"] == "多選"){
              tmpQuestionAns = "" + this.QuestionObj[idx]["QUESTION_ANS"];
            }else if(this.QuestionObj[idx]["QUESTION_TYPE"] == "日期時間"){
              tmpQuestionAns = setToyyyymmdd(this.QuestionObj[idx]["QUESTION_ANS"]);
            }else{
              tmpQuestionAns = this.QuestionObj[idx]["QUESTION_ANS"];
            }
            obj ={
              U_SURVEY_MAIN_GUID:tmpId,
              QUESTION:tmpQuestion,
              ANS:tmpQuestionAns,
              REMARK:tmpQuestionAnsRe,
              SURVEY_USER:this.userName
            };
            objArr.push(obj);
          }
          
        }
      }
      console.log(objArr);
      if(err!= ""){
        alert(err);
      }else{
        const jsonString = JSON.stringify(objArr);
        console.log(jsonString);
        let res = await setSurveyOptionAnsToTxtByJson(
          jsonString
        );
        if(res.status){
          console.log(res);
          alert(res.msg);
        }else{
          alert(res.msg);
        }
      }
      this.Loading =false;
    },
    async submitAction(){
      this.Loading = true;
      this.userName = this.generateSecureGUID();
      //var insertOk = true;
      var objArr =[];
      var err = "";
      for(var idx in this.QuestionObj){
        if(this.QuestionObj[idx]["QUESTION_TYPE"] != "分隔線"){
          var obj = {};
          var tmpId = this.QuestionObj[idx]["ID"];
          var tmpQuestion = this.QuestionObj[idx]["QUESTION"];
          var tmpQuestionAnsRe = this.QuestionObj[idx]["QUESTION_ANS_REMARK"];
          var tmpQuestionAns = "";
          if(this.QuestionObj[idx]["QUESTION_ANS"] == "" || this.QuestionObj[idx]["QUESTION_ANS"] == null){
            err += "【"+tmpQuestion+"】未填無法送出，請確認是否忘記填寫!\r\n";
          }else{
            if(this.QuestionObj[idx]["QUESTION_ANS"] == "其他" && (this.QuestionObj[idx]["QUESTION_ANS_REMARK"] =="" || this.QuestionObj[idx]["QUESTION_ANS_REMARK"] == null)){
              err += "【"+tmpQuestion+"】選其他時，請填寫選項下方輸入框!\r\n";
            }
            if(this.QuestionObj[idx]["QUESTION_TYPE"] == "多選"){
              tmpQuestionAns = "" + this.QuestionObj[idx]["QUESTION_ANS"];
            }else if(this.QuestionObj[idx]["QUESTION_TYPE"] == "日期時間"){
              tmpQuestionAns = setToyyyymmdd(this.QuestionObj[idx]["QUESTION_ANS"]);
            }else{
              tmpQuestionAns = this.QuestionObj[idx]["QUESTION_ANS"];
            }
            obj ={
              U_SURVEY_MAIN_GUID:tmpId,
              QUESTION:tmpQuestion,
              ANS:tmpQuestionAns,
              REMARK:tmpQuestionAnsRe,
              SURVEY_USER:this.userName
            };
            objArr.push(obj);
          }
          
        }
      }
      console.log(objArr);
      if(err!= ""){
        alert(err);
      }else{
        const jsonString = JSON.stringify(objArr);
        console.log(jsonString);
        let res = await setSurveyOptionAnsByJson(
          jsonString
        );
        if(res.status){
          console.log(res);
          alert(res.msg);
        }else{
          alert(res.msg);
        }
      }
      this.Loading =false;
    },
    async getSurveyInfoByGuid(){
      const params = new URLSearchParams(window.location.search);

      const id = params.get('id'); // 取得參數 'id'
      let res = await getSurveyMainInfoByEnable(id);
      if(res.status){
        let JsonObject = setJsonDateDecode(res.data);
        for(let JObj in JsonObject){
          console.log(JsonObject,JObj);
          this.Title = JsonObject[JObj]["TITLE"];
          this.Content = JsonObject[JObj]["CONTENT"];
        }
        var err ="";
        let res2 = await GetSurveyTitleInfo(id);
        if(res2.status){
          let JsonObject = setJsonDateDecode(res2.data);
          for(let JObj in JsonObject){
            console.log(JsonObject,JObj);
            var tmpGUID = JsonObject[JObj]["GUID"];
            let res3 = await GetSurveyOptionInfo(tmpGUID);
            var tmpQuestion = JsonObject[JObj]["QUESTION"];
            var tmpQuestionType = JsonObject[JObj]["QUESTION_TYPE"];
            var tmpQuestionGUID= JsonObject[JObj]["GUID"];
            console.log("-----------------------------------------",tmpQuestionType);
            var defaultAns = "";
            if(tmpQuestionType == "多選" || tmpQuestionType == "多選_下拉式"){
              defaultAns = [];
            }
            if(res3.status){
              let JsonObject = setJsonDateDecode(res3.data);
              var tmpOpt = [];
              for(let JObj in JsonObject){
                tmpOpt.push({
                  ID:JsonObject[JObj]["GUID"],
                  ans:JsonObject[JObj]["QUESTION_OPTION"],
                });
              }
              this.QuestionObj.push({
                ID:id,
                "QUESTION_GUID":tmpQuestionGUID,
                "QUESTION":tmpQuestion,
                "QUESTION_TYPE":tmpQuestionType,
                "QUESTION_ARR": tmpOpt,
                "QUESTION_ANS": defaultAns,
                "QUESTION_ANS_REMARK": ""
              });
            }else{
              err += (res3.msg);
            }
          }
          console.log(this.QuestionObj);
          this.$forceUpdate();
          if("" !== err){
            alert(err);
            this.Title = err;
          }else{
            this.QuestionOpen = true;
          }
        }else{
          alert(res2.msg);
          this.Title = res2.msg;
        }
      }else{
        alert(res.msg);
        this.Title = res.msg;
      }
    },
    generateSecureGUID() {
      const array = new Uint8Array(16);
      crypto.getRandomValues(array);

      array[6] = (array[6] & 0x0f) | 0x40; // 设置版本号为 4
      array[8] = (array[8] & 0x3f) | 0x80; // 设置 variant 为 10

      return [...array]
        .map((b, i) => (i === 4 || i === 6 || i === 8 || i === 10 ? '-' : '') + b.toString(16).padStart(2, '0'))
        .join('');
    }

  },
  components: {
    //HeadComponent
  }
}
</script>
